import React from 'react';
import PropTypes from 'prop-types';

import { SelectBox } from 'components/core/SelectBox';


export function SortBySelectBox({ options = [{
	value: 'recommended',
	display: 'Recommended'
}, {
	value: 'star_rating_sf',
	display: 'Reviews'
}, {
	value: 'price',
	display: 'Price'
}, {
	value: 'distance',
	display: 'Distance'
}], value = 'recommended', handleChange }) {
	return (
		<SelectBox
			id="sort-by"
			label="Sort By"
			onChange={handleChange}
			options={options}
			value={value}
			key={value}
		/>
	);
}

export const enhance = (WrappedComponent) => {
	const WithSortHandler = ({ onChange = () => {}, ...rest }) => {
		const handleChange = (event) => {
			onChange({ order: event.target.value });
		};
		return (
			<WrappedComponent
				{...rest}
				onChange={onChange}
				handleChange={handleChange}
			/>
		);
	};
	return WithSortHandler;
};

SortBySelectBox.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.any,
		display: PropTypes.any
	})),
	value: PropTypes.string,
	handleChange: PropTypes.func
};

export default enhance(SortBySelectBox);
